import styled from 'styled-components';

export const Main = styled.div`
  min-width: 900px;
`;

export const MainArticleContainer = styled.article`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
